export const NAME = 'emailResponse';